import { SidebarAdditionalPackagePayment } from "../shared";
import { SidebarRoamingOffer } from "./SidebarRoamingOffer";

interface ISidebarRoamingProps {
  userFunds: number | undefined;
  hasNoFunds: boolean;
  voicePackageAnniversaryDate: number | undefined;
  dataPackageAnniversaryDate: number | undefined;
  productOfferPrice: number;
  productOfferGrantValue?: string;
}

export function SidebarRoaming({
  hasNoFunds,
  userFunds,
  voicePackageAnniversaryDate,
  dataPackageAnniversaryDate,
  productOfferPrice,
}: ISidebarRoamingProps) {
  return (
    <div className="only-mobile:flex-col">
      <SidebarRoamingOffer
        dataPackageAnniversaryDate={dataPackageAnniversaryDate}
        productOfferPrice={productOfferPrice}
        testId="roaming-package-offer-box"
        voicePackageAnniversaryDate={voicePackageAnniversaryDate}
      />
      <SidebarAdditionalPackagePayment
        hasNoFunds={hasNoFunds}
        productOfferPrice={productOfferPrice}
        testId="roaming-package-payment-box"
        type="roaming"
        userFunds={userFunds}
      />
    </div>
  );
}
